import React from 'react';

import Notifications from '@mui/icons-material/Notifications';
import { useTheme } from '@mui/material/styles';
import { Badge, IconButton } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const NotificationButton = ({ handleToggleDrawer, quantity, sxIcon }) => {
    const theme = useTheme();
    return (
        <IconButton onClick={handleToggleDrawer(true)} size="small">
            <Badge
                badgeContent={quantity}
                sx={{
                    '& .MuiBadge-badge': {
                        backgroundColor: theme.palette.primary.light,
                        color: '#fff',
                    },
                }}
            >
                <Notifications sx={sxIcon} />
            </Badge>
        </IconButton>
    );
};

NotificationButton.propTypes = {
    handleToggleDrawer: PropTypes.func,
    quantity: PropTypes.number,
    sxIcon: PropTypes.object,
};

export default NotificationButton;
